<div class="jit-assignment-content">
  <div class="jit-assignment-content__header">
    <jit-assignment-update-header></jit-assignment-update-header>
  </div>
  <div class="jit-assignment-content__content"></div>
  <div class="jit-assignment-content__footer">
    <jit-assignment-update-footer></jit-assignment-update-footer>
  </div>
</div>
